export function replaceParams(template, params) {
  if (!params) {
    return template;
  }

  let result = template;
  Object.keys(params)
    .filter(k => typeof params[k] === 'string' || typeof params[k] === 'number')
    .forEach(k => {
      result = result.split('%{' + k + '}').join(params[k]);
    });

  const componentKeys = Object.keys(params).filter(
    k => typeof params[k] === 'object' || typeof params[k] === 'function'
  );

  if (componentKeys.length > 0) {
    return interpolateComponents(result, params);
  }

  return result;
}

export function replaceParamsSingularPlural(
  singularTemplate,
  pluralTemplate,
  params,
  count
) {
  if (count === 1) {
    return replaceParams(singularTemplate, params);
  }

  return replaceParams(pluralTemplate, params);
}

export function decodeHtml(str) {
  if (str) {
    // http://stackoverflow.com/questions/3700326/decode-amp-back-to-in-javascript
    const elem = document.createElement('textarea');
    elem.innerHTML = str;
    return elem.value;
  }
  return null;
}

export function encodeHtml(str) {
  if (str) {
    // https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  return '';
}

// Based on https://github.com/martinandert/react-interpolate-component
function interpolateComponents(template, params) {
  return template.split(/%{(.*?)}/).reduce(function(acc, cv, index) {
    if (index % 2 === 0) {
      if (cv.length !== 0) {
        acc.push(cv);
      }
    } else {
      acc.push(params[cv]);
    }
    return acc;
  }, []);
}

export function compareCaseInsensitive(a, b) {
  const aVal = a.toUpperCase();
  const bVal = b.toUpperCase();
  if (aVal < bVal) {
    return -1;
  } else if (aVal > bVal) {
    return 1;
  }
  return 0;
}

export function upcaseFirstLetter(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function downcaseFirstLetter(s) {
  return s.charAt(0).toLowerCase() + s.slice(1);
}

export function dashesToCamelCase(s) {
  const parts = s.split('-');
  return downcaseFirstLetter(
    parts.map(p => upcaseFirstLetter(p.toLowerCase())).join('')
  );
}

export function lengthInBytes(str) {
  return new Blob([str]).size;
}

// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
export function hash(s) {
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    /* eslint-disable no-bitwise */
    hash = s.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    /* eslint-enable no-bitwise */
  }
  return hash;
}

/**
 * @param path
 * @return {string} Lower-cased file name extension, if available. Empty string otherwise.
 */
export function getFileExtension(path) {
  path = path.split('?')[0];
  const index = path.lastIndexOf('.');
  if (index > -1 && index < path.length - 2) {
    const result = path.substring(index + 1).toLowerCase();
    if (result.indexOf('/') === -1) {
      return result;
    }
  }
  return '';
}

export function getFileName(path) {
  const parser = document.createElement('a');
  parser.href = path;

  if (parser.pathname.length <= 1) {
    return decodeURIComponent(parser.hostname);
  }

  return decodeURIComponent(parser.pathname).replace('/', '');
}
